// @flow
import {
    MONTHLYREPORT_LIST,
    MONTHLYREPORT_LIST_SUCCESS,
    MONTHLYREPORT_LIST_FAILED,

} from './constants';

import { getLoggedInUser } from '../../helpers/authUtils';

const INIT_STATE = {
    user: getLoggedInUser(),
    loading: false,
};

type MonthlyreportAction = { type: string, payload: {} | string };
type State = { user?: {} | null, loading?: boolean, +value?: boolean };

const Monthlyreport = (state: State = INIT_STATE, action: MonthlyreportAction) => {
    switch (action.type) {
        case MONTHLYREPORT_LIST:
            return { ...state, listloading: true };
        case MONTHLYREPORT_LIST_SUCCESS:
            return { ...state, monthlyreport: action.payload, listloading: false, error: null };
        case MONTHLYREPORT_LIST_FAILED:
            return { ...state, error: action.payload, loading: false };
      

        default:
            return { ...state };
    }
};

export default Monthlyreport;
